import { type ComponentType, type ReactNode } from 'react';
import { MTableBody } from '@material-table/core';
import { WindowScroller, List } from 'react-virtualized';
import TableRowRenderer from '../TableRowRenderer';

/*
  Original MTableBody's 'renderUngroupedRows' method implementation is taken from:
  https://github.com/material-table-core/core/blob/v0.2.37/src/components/m-table-body.js
  The second part is in the 'TableRowRenderer' component.
*/

const TD_STYLE = { padding: 0 };

// @ts-ignore
class TableBody extends MTableBody {
  // @ts-ignore
  renderUngroupedRows(renderData) {
    if (!renderData.length) {
      return null; // no data case
    }

    const {
      rowHeight,
      tableRef,
      selection,
      ...restMTableBodyProps
      // @ts-ignore
    } = this.props;

    if (!tableRef.current) {
      return null;
    }

    // @ts-ignore
    const colSpan = this.props.columns.length + (selection ? 1 : 0);

    return (
      <tr>
        <td colSpan={colSpan} style={TD_STYLE}>
          <WindowScroller scrollElement={tableRef.current.tableContainerDiv.current.offsetParent}>
            {({
              width = 0,
              height = 0,
              isScrolling,
              onChildScroll,
              scrollTop,
              registerChild,
            }) => (
              <div ref={(elm) => {
                if (elm) {
                  registerChild(elm as unknown as ReactNode); // removes findDOMNode warning
                }
              }}
              >
                <List
                  width={width}
                  height={height}
                  autoWidth
                  autoHeight
                  rowCount={renderData.length}
                  rowHeight={rowHeight}
                  rowRenderer={(listProps) => {
                    const { key, style, index } = listProps;
                    return (
                      <table key={key} style={{ ...style, borderSpacing: 0 }}>
                        <tbody>
                          <TableRowRenderer {...restMTableBodyProps} index={index} />
                        </tbody>
                      </table>
                    );
                  }}
                  isScrolling={isScrolling}
                  onScroll={onChildScroll}
                  scrollTop={scrollTop}
                />
              </div>
            )}
          </WindowScroller>
        </td>
      </tr>
    );
  }
}

export default TableBody as unknown as ComponentType<any>;
